import { PasswordRules } from '../services/requests';
import {
  regExpLowercase,
  regExpNonASCIIcharacters,
  regExpNumber,
  regExpSpecial,
  regExpUppercase,
} from './regExp';

export const getPasswordRequirementState = (password: string): PasswordRules => ({
  matchLength: password !== undefined && password.length >= 10 && password.length <= 64,
  includeUppercase: password !== undefined && regExpUppercase.test(password),
  includeLowercase: password !== undefined && regExpLowercase.test(password),
  includeNumber: password !== undefined && regExpNumber.test(password),
  includeSpecialSymbol:
    password !== undefined &&
    regExpSpecial.test(password) &&
    regExpNonASCIIcharacters.test(password),
});
